export default "__VITE_ASSET__357ed4ef__"